import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { DriverModel } from './../../driver/models/driver.model';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { PersonService } from '../../person/models/person.service';
import { PersonModel } from '../../person/models/person.model';

@Component({
  selector: 'wego-booking-request-admin-popup',
  template: require('../views/booking-request-admin-popup.component.html'),
  providers: [PersonService]
})

export class BookingRequestAdminPopupComponent implements OnInit, OnChanges {
  SelectedNames: string[] = [];
  SelectedList: string[] = [];
  DataListModel: DataListModel;
  adminList: PersonModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  LblIcon: string = "fa fa-plus-square";
  isParentCheck: boolean = false;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('adminModal') public adminModal: any;

  constructor(private personService: PersonService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(SelectedList: string[], SelectedNamesList: string[]): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.SelectedList = SelectedList;
    this.SelectedNames = SelectedNamesList;
    this.GetAdminList();
    this.adminModal.show();
  }

  public hide(): void {
    this.adminModal.hide();
  }

  private GetAdminList() {
    this.isLoading = true;
    this.personService.GetAdminList(this.DataListModel)
      .subscribe(
      res => {
        this.adminList = res.data;
        this.adminList.forEach(x => x.isChecked =
          (this.SelectedList.indexOf(x.personMasterHashId) > -1)
        );        
        this.isParentCheck = this.adminList.every(x => x.isChecked);
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(person: PersonModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ PersonHashID: person.personMasterHashId, UserName: person.userName });
    this.isLoading = false;
    this.hide();
  }

  private selectMultiple(): void {
    this.isLoading = true;

    this.onSuccessSelect.emit({ PersonHashID: this.SelectedList, UserName: this.SelectedNames });
    this.isLoading = false;
    this.hide();
  }

  private ItemCheckChanged(personHashID: string, personName: string, isChecked: any) {
    if (isChecked) {
      if (this.SelectedList.indexOf(personHashID) == -1) {
        this.SelectedList.push(personHashID);
      }
      if (this.SelectedNames.indexOf(personName) == -1) {
        this.SelectedNames.push(personName);
      }
      this.isParentCheck = this.adminList.filter(x => x.personMasterHashId != personHashID).every(x => x.isChecked);
    } else {
      this.SelectedList = this.SelectedList.filter(x => x != personHashID);
      this.SelectedNames = this.SelectedNames.filter(x => x != personName);
      this.isParentCheck = false;
    }
  }

  public OnParentCheck(isChecked: boolean) {
    this.adminList.forEach(x => {
      x.isChecked = isChecked;
      if (isChecked) {
        if (this.SelectedList.indexOf(x.personMasterHashId) == -1) {
          this.SelectedList.push(x.personMasterHashId);
        }
        if (this.SelectedNames.indexOf(x.userName) == -1) {
          this.SelectedNames.push(x.userName);
        }
      } else {
        this.SelectedList = this.SelectedList.filter(y => y != x.personMasterHashId);
        this.SelectedNames = this.SelectedNames.filter(y => y != x.userName);
      }
    });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetAdminList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetAdminList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetAdminList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetAdminList();
  }
  private OnSuccessSelect() {
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-request-admin-popup.component.ts